import { useGlobalStore } from "@/app/context/globalStoreProvider";
import { deriveStatusChallenge } from "@/lib/statusChallengeState";
import { useActiveStatusChallenge } from "./useActiveStatusChallenge";

const useStatusChallenge = () => {
  const { user, userCreditsData } = useGlobalStore();
  const { challenge, loading, settled } = useActiveStatusChallenge();
  return deriveStatusChallenge({
    user: user?.data,
    credits: userCreditsData?.userCredits,
    activeChallenge: challenge,
    loading,
    settled,
  });
};
export default useStatusChallenge;
